import { useContext, useEffect, useState } from "react";
import { SelectedServiceContext } from "@context/ISelectedContext";
import { IBarring } from "../interface/IBarrings";
import { getBarringRoute } from "@api-routes/barrings";
import { getResponseToState, IBarringListResponse } from "../mappers/getBarringListMapper";
import { useFetch } from "@common/hook/useFetch";

export const useBarringList = () => {
    const { selectedService } = useContext(SelectedServiceContext);
    const [barringList, setBarringList] = useState<IBarring[]>([]);
    const [getBarringListState, { get }] = useFetch();

    const getBarringList = () => {
        if (selectedService) {
            get<IBarringListResponse>(getBarringRoute(selectedService.id)).then((barringListResponse) => {
                if (barringListResponse) {
                    setBarringList(getResponseToState(barringListResponse));
                }
            });
        }
    };

    useEffect(() => {
        getBarringList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedService]);

    return { getBarringListState, barringList, getBarringList };
};
